/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import styled from '@emotion/styled'
import React from 'react'
import { CardSection, Heading } from './CardSection'

export type UnavailableDiseasesProps = {
  diseases: string[]
  text: string
}

export const UnavailableDiseases = ({
  diseases,
  text,
}: UnavailableDiseasesProps) => {
  return (
    <CardSection>
      <Heading>ご利用いただけない病気</Heading>
      <div>
        {diseases
          .filter((name) => name.length > 0)
          .map((name, i) => (
            // TODO: react/jsx-key の無効化を外す。
            /* eslint-disable-next-line react/jsx-key */
            <DiseaseItem>
              {name}
              {i !== diseases.length - 1 && <span>、</span>}
            </DiseaseItem>
          ))}
      </div>
      {text && text.trim().length > 0 && (
        <div
          style={{
            marginTop: '10px',
          }}
        >
          {text}
        </div>
      )}
    </CardSection>
  )
}

const DiseaseItem = styled.span(css`
  display: inline-block;
`)
